/** @param {string} root */
export default function url(root) {
    if (root === "#") return root;
    if (root.includes(";jsessionid")) {
        return root;
    }
    const pieces = root.split('?', 2);
    let rootParams;
    let base = root;
    if (pieces.length === 2) {
        base = pieces[0];
        rootParams = "?" + pieces[1];
    } else {
        rootParams = "";
    }
    const locPieces = location.pathname.split(';');
    if (locPieces.length === 2) {
        return base + ";" + locPieces[1] + rootParams;
    } else {
        return base + rootParams;
    }
}
